export default "__VITE_ASSET__BHbRjqBp__"